import lookup from './lookup';

export default function translate(msg) {
  return Object.entries(lookup).find(([key]) => key === msg)?.[1]?.de || { text: msg };
}
